import { render } from "./trainingVideoCompany.vue?vue&type=template&id=6fb182ae&scoped=true"
import script from "./trainingVideoCompany.vue?vue&type=script&lang=js"
export * from "./trainingVideoCompany.vue?vue&type=script&lang=js"

import "./trainingVideoCompany.vue?vue&type=style&index=0&id=6fb182ae&scoped=true&lang=scss"

import exportComponent from "H:\\Environment_蓝宇\\Src\\GZXY\\GZEUA\\GZ_CQ_V2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb182ae"]])

export default __exports__